import axios from '@/utils/axios';

// 登录
export function login(username, password) {
  return axios({
    url: '/account/login',
    method: 'post',
      params: { username, password },
  });
}

// 登出
export function logout() {
  return axios({
    url: '/account/logout',
    method: 'post',
      params: {},
  });
}

// 获取菜单
export function menuInfo() {
  return axios({
    url: '/account/menu/list',
    method: 'get',
    params: {},
  });
}

// 获取个人信息详情
export function account() {
    return axios({
        url: '/account',
        method: 'get',
        params: {},
    });
}


//用户微信授权
export function WeChatUserInfo( code ) {
    return axios({
        url: '/wechat/userInfo',
        method: 'post',
        params: { code },
    });
}

//获取系统状态
export function SystemStatus() {
    return axios({
        url: '/sysOpt/maintenance/status',
        method: 'get',
        params: { },
    });
}

//配送员规则说明
export function SystemRule() {
    return axios({
        url: '/sysOpt',
        method: 'get',
        params: { },
    });
}